import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Instagram, Facebook, ArrowUpRight } from 'lucide-react';
import tomStudio from '@/assets/tom-studio.jpg';

const FB_PAGE_URL = 'https://www.facebook.com/profile.php?id=100087669492219';
const IG_URL = 'https://www.instagram.com/tom_art_mask/';

const SocialFeed = () => {
  const { t } = useLanguage();

  return (
    <section id="social" className="py-20 md:py-32 px-4">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2
            className="text-5xl md:text-7xl tracking-wider text-foreground"
            style={{ fontFamily: 'Bebas Neue' }}
          >
            {t.social.title}
          </h2>
          <p className="mt-4 text-muted-foreground text-lg max-w-2xl mx-auto">
            {t.social.subtitle}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-stretch rounded-sm border border-border/50 bg-card/30 backdrop-blur-sm p-6 md:p-10 hover:border-primary/30 hover:shadow-[0_0_40px_hsl(var(--primary)/0.1)] transition-all duration-500"
        >
          {/* Levý sloupec — fotka */}
          <div className="relative overflow-hidden rounded-sm aspect-[4/5] lg:aspect-auto lg:min-h-[420px] bg-black">
            <img
              src={tomStudio}
              alt="Tomáš Veselý — Tom Art Mask studio"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          </div>

          {/* Pravý sloupec — text + CTA */}
          <div className="flex flex-col justify-center gap-6">
            <h3
              className="text-3xl md:text-4xl tracking-wide text-foreground"
              style={{ fontFamily: 'Bebas Neue' }}
            >
              @tom_art_mask
            </h3>

            <p className="text-foreground/80 leading-relaxed text-base md:text-lg">
              {t.social.subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mt-2">
              <a
                href={FB_PAGE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center justify-center gap-3 px-6 py-4 rounded-sm bg-[#1877F2] text-white font-semibold uppercase tracking-widest text-sm hover:bg-[#166FE5] transition-all duration-300 hover:shadow-[0_0_25px_rgba(24,119,242,0.4)]"
              >
                <Facebook size={20} />
                Facebook
                <ArrowUpRight
                  size={18}
                  className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                />
              </a>

              <a
                href={IG_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center justify-center gap-3 px-6 py-4 rounded-sm bg-gradient-to-r from-[#f09433] via-[#e6683c] to-[#dc2743] text-white font-semibold uppercase tracking-widest text-sm hover:opacity-95 transition-all duration-300 hover:shadow-[0_0_25px_rgba(220,39,67,0.4)]"
              >
                <Instagram size={20} />
                Instagram
                <ArrowUpRight
                  size={18}
                  className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                />
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SocialFeed;
